import { CalendarInstance } from '../pages/calendar/calendar';

(() => {
    if (CalendarInstance) {
        CalendarInstance.init()
    }
})();